<template>
<div id="footer">
	<div class="section">
		<!--<div>
		<router-link to="/faq">
			<span>{{$t('caption.helpfooter')}}</span>
		</router-link>
		</div>-->

		
		<!--
		<div class="appbadges" v-if="!cordova">
			<a href="https://play.google.com/store/apps/details?id=app.snippity">
				<img src="img/badges/googleplay.png" />
			</a>
	
			<a href="">
				<img src="img/badges/appstore.png" />
			</a>

			<a href="">
				<img src="img/badges/rustore.png" />
			</a>

		</div>-->

		<div v-if="!cordova">
			<router-link to="/applications">
				<span>{{$t('common.2901046')}}</span>
			</router-link>
		</div>

		<div>
		<router-link to="/about">
			<span>{{$t('caption.about')}}</span>
		</router-link>
		</div>

		<div>
		<router-link to="/partnership">
			<span>{{$t('plans.promos')}}</span>
		</router-link>
		</div>

		<div>
			<router-link to="/privacy">
				<span>{{$t('caption.privacy')}}</span>
			</router-link>
		</div>
		<div>
			<router-link to="/terms">
				<span>{{$t('caption.terms')}}</span>
			</router-link>
		</div>
		<div>
			<router-link to="/csae">
				<span>{{$t('caption.csae')}}</span>
			</router-link>
		</div>


		
	</div>
	
</div>
</template>

<style scoped lang="sass">
#footer
	margin-top: 8 * $r
	padding-bottom: 8 * $r

.section
	display: flex
	flex-flow: column
	div
		margin-top: $r
	span
		
		text-decoration: underline
		font-size: 0.8em

.appbadges
	display: flex
	margin-bottom: 2 * $r
	img
		height: 36px
		margin-right: $r
</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'footerComponent',
	props: {
		data: Object
	},
	computed: mapState({
		auth: state => state.auth,
		cordova : () => window.cordova
	}),

	methods: {

	},
}
</script>
